import { render, staticRenderFns } from "./UserAudit.vue?vue&type=template&id=40c2c16c&"
import script from "./UserAudit.vue?vue&type=script&lang=js&"
export * from "./UserAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports